import Vue from 'vue'
import Vuex from 'vuex'
import BackendService from '@/services/requests/backendService'
import FrontendConfigService from '@/services/configs/frontendConfigService'
Vue.use(Vuex)

const agendamentosTodosStore = new Vuex.Store({
  state: {
    loading: false,

    agendas: [],
    loadingAgendas:false,

    salas:[],
    loadingSalas:false,

    notifications:[]

  },
  mutations: {
    setLoading(state, value) { state.loading = value },
    
    setAgendas(state, value) { state.agendas = value },
    setLoadingAgendas(state, value) { state.loadingAgendas = value },
    
    setSalas(state, value) { state.salas = value },
    setLoadingSalas(state, value) { state.loadingsalas = value },
    
    setNotifications(state, value){ 
			state.notifications = value 
		}
  },
  getters:{ 
    getIsLoading(state){
      return state.loading || state.loadingAgendas || state.loadingSalas
    },
    getEventos(state){
      let eventos = state.agendas.map( obj => {
        return {
          codturma : obj.codturma,
          titulo_aula : obj.titulo_aula,
          status_agenda : obj.status_agenda,
          solicitante : obj.solicitante,
          data : `${obj.get_formatted_data} ${obj.start.substr(0,5)} às ${obj.end.substr(0,5)}`,
          horario : `${obj.start.substr(0,5)} às ${obj.end.substr(0,5)}`,
          name : obj.titulo_aula,
          start : `${obj.data}T${obj.start}`,
          end : `${obj.data}T${obj.end}`,
          color : obj.get_sala.cor,
          timed : false,
          category : obj.get_sala.sala,
          curso : obj.curso,
          disciplina : obj.disciplina,
          finalidade : obj.get_finalidade.descricao,
          formatted_data : `${obj.get_formatted_data} ${obj.start} às ${obj.end}`,
          file_protocolo_pratica : obj.file_protocolo_pratica,
          file_reagentes_equipamentos : obj.file_reagentes_equipamentos,
        }
      })
      //console.log(eventos.length,' eventos')
      //console.log(eventos,'lista eventos')
      return eventos
    },
    getSalasCategory(state){
      let categories = state.salas.map( obj => {
        return obj.sala
      })
      return categories
    },
    getNotifications(state){
			return state.notifications
		},
  },
  actions: {
    tryError: async(context, error)=>{
			let err = FrontendConfigService.tryNotificationErrors(error)
			context.commit('setNotifications', [{'tag':err.tag, 'message': err.message}])
		},
    get_agendas: async (context, params)=>{
      //console.log(params)
      const req = new BackendService()
      context.commit('setLoadingAgendas', true)
      return await req.get_agendamentos(params)
      .then( response => { 
        context.commit('setAgendas', response.data)
      }).catch( error => { 
        console.error(error.response); 
        context.commit('setAgendas', [])
        context.dispatch('tryError', error)
      }).finally( () => { 
        context.commit('setLoadingAgendas', false) 
      })
    },
    get_salas: async (context)=>{
      const req = new BackendService()
      context.commit('setLoadingSalas', true)
      return await req.get_salas()
      .then( response => { 
        context.commit('setSalas', response.data)
      }).catch( error => { 
        console.error(error.response); 
        context.dispatch('tryError', error)
      }).finally( () => { 
        context.commit('setLoadingSalas', false) 
      })
    },
  }
})

export default agendamentosTodosStore
